import { BuyPlanPageQuery } from './BuyPlanPageQuery'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { ParsedUrlQueryInput } from 'querystring'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { UrlObject } from 'url'
import { serializePlanTypeQueryParam } from '@dtx-company/true-common/src/query-string-serialization/planType/serializePlanTypeQueryParam'

interface CreateBuyPlanPageUrlObjectOptions {
  includeRoot?: boolean
  query: BuyPlanPageQuery
}

function buildQuery(query: BuyPlanPageQuery): ParsedUrlQueryInput {
  const parsed: ParsedUrlQueryInput = {}
  if (query.from) parsed.from = query.from
  parsed.planType = serializePlanTypeQueryParam(query.planType)?.toLocaleLowerCase()
  if (query.promoCode) parsed.promoCode = query.promoCode
  if (query.utm_source) parsed.utm_source = query.utm_source
  return parsed
}

export function createBuyPlanPageUrlObject(options: CreateBuyPlanPageUrlObjectOptions): UrlObject {
  return {
    pathname: (options.includeRoot ? FLOWCODE_ROOT : '') + Routes.BUY_PLAN_PAGE,
    query: buildQuery({ ...options.query })
  }
}
